import byKeyMaker from 'reducersMakers/byKeyMaker';
import firstLevel from './firstLevel/reducer';
import secondLevel from './secondLevel/reducer';

export default byKeyMaker('key', {
  firstLevel,
  secondLevel
});



/** WEBPACK FOOTER **
 ** ./src/members/state/comments/textEditing/reducer.js
 **/